import { SyntheticEvent } from 'react';

import { useFormContext } from 'react-hook-form';

export function useLadderToggle() {
  const { register, unregister, setValue } = useFormContext();

  const onSwitcherChange = (_: SyntheticEvent, checked: boolean) => {
    if (checked) {
      register('ladder');
      unregister('rate');
      setValue('rate.zeroed', false);
    } else {
      unregister('ladder');
      register('rate');
    }
    setValue('isLadder', checked);
  };
  return { onSwitcherChange };
}
